<template>
  <div class="sky-hc-setting">
    <el-form label-position="top" :model="settingConfigForm" :rules="rules">
      <el-form-item :label="$t('setting.banner')" prop="bannerImg" verify>
        <Upload
          uploadClass="sky-hc-upload__uploader-index"
          :imgUrl="settingConfigForm.bannerImg"
          @handleUploadFile="handleUploadFile"
        ></Upload>
      </el-form-item>
      <el-form-item :label="$t('setting.linkAddress')" prop="bannerLink" verify>
        <el-input v-model="settingConfigForm.bannerLink"></el-input>
      </el-form-item>
    </el-form>
    <div class="sky-hc-setting__modules">
      <span
        class="sky-hc-setting__module-item"
        v-for="(item, index) in modules"
        :key="'00' + index"
        :class="index === activeModuleIndex ? 'sky-hc-setting__module-item--active' : ''"
        @click="handleChooseModule(index)"
        >{{ item }}</span
      >
    </div>
    <div class="sky-hc-setting__category" v-for="(item, index) in categoryList" :key="index">
      <span
        class="sky-hc-setting__category-item"
        v-for="(subItem, subIndex) in item"
        :key="'0' + subIndex"
        @click="handleChooseCategory(index, subIndex)"
        :class="
          activeIndex[activeModuleIndex].index === index && activeIndex[activeModuleIndex].subIndex === subIndex
            ? 'sky-hc-setting__category-item--active'
            : ''
        "
      >
        {{ subItem.name }}
      </span>
    </div>
    <div class="sky-hc-setting__btns">
      <el-button class="sky-hc-setting__btn" @click="handleGetIndexConfig">{{ $t('cancel') }}</el-button>
      <el-button class="sky-hc-setting__btn" type="primary" @click="handleSetIndexConfig">{{
        $t('articleManage.save')
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { Form, FormItem, Input, Button } from 'element-ui'

import { getCategoryList } from '@/api/articleManage'
import { getIndexConfig, setIndexConfig } from '@/api/setting'

import Upload from '@/components/upload'
import { CATEGORY_TYPE } from '@/utils/enum'
import { FormValidate } from '@/utils/formValidate'
export default {
  name: 'IndexSetting',
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
    Upload
  },
  data() {
    return {
      categoryList: [],
      modules: [
        this.$t('setting.moduleOne'),
        this.$t('setting.moduleTwo'),
        this.$t('setting.moduleThree'),
        this.$t('setting.moduleFour')
      ],
      activeModuleIndex: 0,
      activeIndex: [
        {
          index: 0,
          subIndex: 0
        },
        {
          index: 0,
          subIndex: 0
        },
        {
          index: 0,
          subIndex: 0
        },
        {
          index: 0,
          subIndex: 0
        }
      ],
      settingConfigForm: {
        bannerImg: '',
        bannerLink: ''
      },
      modulesConfig: [],
      rules: {
        bannerLink: [
          [
            {
              validator: FormValidate.validateURL
            }
          ]
        ]
      }
    }
  },
  created() {
    this.handleGetCategoryList()
  },
  methods: {
    handleGetCategoryList() {
      getCategoryList({ type: CATEGORY_TYPE.ARTICLE }).then(response => {
        const data = response.data.content.itemArr
        const categoryList = []
        for (let i = 0; i < data.length; i++) {
          let categorySubList = []
          categorySubList.push(Object.assign(data[i], { isParent: true }))
          if (data[i].children && data[i].children.length) {
            for (let j = 0; j < data[i].children.length; j++) {
              categorySubList.push(data[i].children[j])
            }
          }
          categoryList.push(categorySubList)
        }
        this.categoryList = categoryList
        this.handleGetIndexConfig()
      })
    },
    handleChooseModule(index) {
      this.activeModuleIndex = index
    },
    handleChooseCategory(index, subIndex) {
      this.activeIndex[this.activeModuleIndex] = {
        index,
        subIndex
      }
      this.activeIndex.splice(0, 0)
    },
    handleUploadFile(url) {
      this.$set(this.settingConfigForm, 'bannerImg', url)
    },
    handleGetIndexConfig() {
      getIndexConfig().then(response => {
        const data = response.data.content
        this.settingConfigForm = Object.assign({}, data)
        for (let i in this.categoryList) {
          for (let j in this.categoryList[i]) {
            if (this.categoryList[i][j].id === data.modules[0].categoryId) {
              this.activeIndex[0] = {
                index: Number(i),
                subIndex: Number(j)
              }
            }
            if (this.categoryList[i][j].id === data.modules[1].categoryId) {
              this.activeIndex[1] = {
                index: Number(i),
                subIndex: Number(j)
              }
            }
            if (this.categoryList[i][j].id === data.modules[2].categoryId) {
              this.activeIndex[2] = {
                index: Number(i),
                subIndex: Number(j)
              }
            }
            if (this.categoryList[i][j].id === data.modules[3].categoryId) {
              this.activeIndex[3] = {
                index: Number(i),
                subIndex: Number(j)
              }
            }
          }
        }
        this.activeIndex.splice(0, 0)
      })
    },
    handleSetIndexConfig() {
      setIndexConfig(
        Object.assign(this.settingConfigForm, {
          modules: [
            {
              categoryId: this.categoryList[this.activeIndex[0].index][this.activeIndex[0].subIndex].id,
              categoryName: this.categoryList[this.activeIndex[0].index][this.activeIndex[0].subIndex].name
            },
            {
              categoryId: this.categoryList[this.activeIndex[1].index][this.activeIndex[1].subIndex].id,
              categoryName: this.categoryList[this.activeIndex[1].index][this.activeIndex[1].subIndex].name
            },
            {
              categoryId: this.categoryList[this.activeIndex[2].index][this.activeIndex[2].subIndex].id,
              categoryName: this.categoryList[this.activeIndex[2].index][this.activeIndex[2].subIndex].name
            },
            {
              categoryId: this.categoryList[this.activeIndex[3].index][this.activeIndex[3].subIndex].id,
              categoryName: this.categoryList[this.activeIndex[3].index][this.activeIndex[3].subIndex].name
            }
          ]
        })
      )
    }
  }
}
</script>
